module.exports = fox._r("images/progress-line-bg.png", __webpack_public_path__ + "_/_/_/common/frame/images/progress-line-bg.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/progress-line-bg.png
// module id = 98
// module chunks = 2